function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { Entity } from "./Entity";
import { Color } from "./Color";
/**
 * An object which holds list of colors and can generate new ones.
 *
 * @see {@link https://www.amcharts.com/docs/v5/concepts/colors-gradients-and-patterns/#Color_sets} for more info
 */
export var ColorSet = /*#__PURE__*/function (_Entity) {
  _inherits(ColorSet, _Entity);
  var _super = _createSuper(ColorSet);
  function ColorSet() {
    _classCallCheck(this, ColorSet);
    return _super.apply(this, arguments);
  }
  _createClass(ColorSet, [{
    key: "_afterNew",
    value:
    //protected _currentPass: number = 0;
    function _afterNew() {
      // Applying themes because color set will not have parent
      _get(_getPrototypeOf(ColorSet.prototype), "_afterNewApplyThemes", this).call(this);
      this._dirty["colors"] = false;
    }
  }, {
    key: "_beforeChanged",
    value: function _beforeChanged() {
      if (this.isDirty("colors")) {
        this.reset();
      }
    }
    /**
     * @ignore
     */
  }, {
    key: "generateColors",
    value: function generateColors() {
      this.setPrivate("currentPass", this.getPrivate("currentPass", 0) + 1);
      var pass = this.getPrivate("currentPass");
      var colors = this.get("colors", [this.get("baseColor", Color.fromHex(0xff0000))]);
      if (!this.getPrivate("numColors")) {
        this.setPrivate("numColors", colors.length);
      }
      //const len = colors.length;
      var len = this.getPrivate("numColors");
      //const start = len - this.getPrivate("numColors")!;
      var start = 0;
      var passOptions = this.get("passOptions");
      var reuse = this.get("reuse");
      for (var i = start; i < len; i++) {
        if (reuse) {
          colors.push(colors[i]);
        } else {
          var hsl = colors[i].toHSL();
          var h = hsl.h + (passOptions.hue || 0) * pass;
          while (h > 1) h -= 1;
          var s = hsl.s + (passOptions.saturation || 0) * pass;
          //if (s > 1) s -= Math.floor(s);
          if (s > 1) s = 1;
          if (s < 0) s = 0;
          var l = hsl.l + (passOptions.lightness || 0) * pass;
          //if (l > 1) l -= Math.floor(l);
          while (l > 1) l -= 1;
          colors.push(Color.fromHSL(h, s, l));
        }
      }
    }
    /**
     * Returns a [[Color]] at specific index.
     *
     * If there's no color at this index, a new color is generated.
     *
     * @param   index  Index
     * @return         Color
     */
  }, {
    key: "getIndex",
    value: function getIndex(index) {
      var colors = this.get("colors", []);
      var saturation = this.get("saturation");
      if (index >= colors.length) {
        this.generateColors();
        return this.getIndex(index);
      }
      return saturation != null ? Color.saturate(colors[index], saturation) : colors[index];
    }
    /**
     * Returns next [[Color]] in the list.
     *
     * If the list is out of colors, new ones are generated dynamically.
     */
  }, {
    key: "next",
    value: function next() {
      var currentStep = this.getPrivate("currentStep", this.get("startIndex", 0));
      this.setPrivate("currentStep", currentStep + this.get("step", 1));
      return this.getIndex(currentStep);
    }
    /**
     * Resets counter to the start of the list, so the next call for `next()` will
     * return the first color.
     */
  }, {
    key: "reset",
    value: function reset() {
      this.setPrivate("currentStep", this.get("startIndex", 0));
      this.setPrivate("currentPass", 0);
    }
  }]);
  return ColorSet;
}(Entity);
Object.defineProperty(ColorSet, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "ColorSet"
});
Object.defineProperty(ColorSet, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Entity.classNames.concat([ColorSet.className])
});